export default "__VITE_ASSET__1141c5ae__"